export enum PDFTitles {
  FULL = 'Full Candidate Profile',
  BASIC = 'Basic Candidate Profile',
  GRAPHS = 'Candidate Assessment Graphs'
}
